import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { TextLinkButton, styleVariables } from '@lib/common';
import { Skeleton, Popover, Space } from 'antd';
import { MoreOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CollapseContainer = styled.div.withConfig({
  displayName: "section-summarycomponent__CollapseContainer",
  componentId: "sc-je482m-0"
})(["display:flex;flex-direction:column;height:inherit;"]);
var QuestionDescription = styled.label.withConfig({
  displayName: "section-summarycomponent__QuestionDescription",
  componentId: "sc-je482m-1"
})(["overflow:hidden;p{margin:0;overflow:hidden;text-overflow:ellipsis;cursor:pointer;}"]);
var PanelSection = styled.div.withConfig({
  displayName: "section-summarycomponent__PanelSection",
  componentId: "sc-je482m-2"
})(["height:52px;padding:16px 0px 16px 24px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid ", ";box-shadow:inset 0 0 0 1px transparent;font-size:15px;width:100%;transition:all 0.2s ease;font-weight:600;&.active{background-color:", ";font-size:14px;color:", ";}&:hover{color:", ";}cursor:pointer;"], styleVariables.colors.gray3, styleVariables.colors.gray8, styleVariables.colors.blue4, styleVariables.colors.blue4);
var PanelQuestion = styled.div.withConfig({
  displayName: "section-summarycomponent__PanelQuestion",
  componentId: "sc-je482m-3"
})(["max-height:0;overflow:hidden;transition:max-height 0.4s ease;overflow-y:scroll;cursor:pointer;&::-webkit-scrollbar{width:0;}&.expand{max-height:100vh;transition:max-height 0.4s ease;}"]);
var PanelTitleSection = styled.span.withConfig({
  displayName: "section-summarycomponent__PanelTitleSection",
  componentId: "sc-je482m-4"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;span{font-size:12px;opacity:50%;}"]);
var PanelScoreSection = styled(PanelTitleSection).withConfig({
  displayName: "section-summarycomponent__PanelScoreSection",
  componentId: "sc-je482m-5"
})(["white-space:normal;overflow:visible;text-overflow:clip;"]);
var QuestionTitleWrapper = styled.div.withConfig({
  displayName: "section-summarycomponent__QuestionTitleWrapper",
  componentId: "sc-je482m-6"
})(["display:flex;width:84%;height:16px;cursor:pointer;"]);
var PanelTitleQuestion = styled.div.withConfig({
  displayName: "section-summarycomponent__PanelTitleQuestion",
  componentId: "sc-je482m-7"
})(["height:42px;margin-right:6px;white-space:nowrap;cursor:pointer;font-size:12px;border-bottom:1px solid ", ";padding:16px 40px 16px 24px;transition:all 0.2s ease;display:flex;align-items:center;justify-content:space-between;width:100%;background:", ";&.active{transition:all 0.2s ease;color:", ";.ql-editor p{color:", ";}}&:hover{color:", ";transition:all 0.2s ease;.ql-editor p{color:", ";}opacity:0.8;}"], styleVariables.colors.gray7, styleVariables.colors.gray2, styleVariables.colors.blue4, styleVariables.colors.blue4, styleVariables.colors.blue4, styleVariables.colors.blue4);
var PanelTitleTotalScore = styled.div.withConfig({
  displayName: "section-summarycomponent__PanelTitleTotalScore",
  componentId: "sc-je482m-8"
})(["white-space:nowrap;cursor:pointer;margin-top:auto;font-size:15px;padding:12px 24px;transition:all 0.2s ease;display:flex;align-items:center;justify-content:space-between;font-weight:600;"]);
var activeClass = 'active';
var expandClass = 'expand';
var SectionSummaryListContainer = styled.div.withConfig({
  displayName: "section-summarycomponent__SectionSummaryListContainer",
  componentId: "sc-je482m-9"
})(["overflow-y:scroll;height:auto;max-height:68vh;::-webkit-scrollbar{width:3px;}::-webkit-scrollbar-thumb{border-radius:10px;background-color:", ";}@supports (overflow:overlay){overflow:overlay;}"], styleVariables.colors.gray8);
var StyledTextLinkButton = styled(TextLinkButton).withConfig({
  displayName: "section-summarycomponent__StyledTextLinkButton",
  componentId: "sc-je482m-10"
})(["color:", ";font-weight:500;line-height:24px;"], styleVariables.colors.blue4);
var LoadingArea = styled.div.withConfig({
  displayName: "section-summarycomponent__LoadingArea",
  componentId: "sc-je482m-11"
})(["padding:16px 24px;"]);
var MoreButton = styled(TextLinkButton).withConfig({
  displayName: "section-summarycomponent__MoreButton",
  componentId: "sc-je482m-12"
})(["width:10px !important;background:'green' !important;"]);
export var SectionSummaryComponent = function SectionSummaryComponent(props) {
  var sections = props.sections,
      sectionSelectedIndex = props.sectionSelectedIndex,
      sectionsExpand = props.sectionsExpand,
      onUpdateSectionSelected = props.onSelectedSection,
      onSelectQuestion = props.onSelectedQuestion,
      selectedQuestionIndex = props.selectedQuestionIndex,
      isLoadingGetQuestionSummaries = props.isLoadingGetQuestionSummaries,
      totalQuestionScore = props.totalQuestionScore,
      onCreateSection = props.onCreateSection;

  var _useState = useState(),
      openPopoverSectionId = _useState[0],
      setOpenPopoverSectionId = _useState[1];

  var generateSectionActiveClass = useCallback(function (sectionIndex) {
    var sectionActiveClass = sectionSelectedIndex === sectionIndex + 1 && activeClass;
    return sectionActiveClass;
  }, [sectionSelectedIndex]);
  var generateSectionExpandClass = useCallback(function (sectionIndex) {
    var sectionExpandClass = sectionsExpand.includes(sectionIndex + 1) && expandClass;
    return sectionExpandClass;
  }, [sectionsExpand]);

  var moreContent = function moreContent(section) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsx(StyledTextLinkButton, {
          onClick: function onClick(e) {
            e.stopPropagation();
            onCreateSection(section.previousSectionId);
            setOpenPopoverSectionId('');
          },
          icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
          children: "Th\xEAm ph\u1EA7n b\xEAn tr\xEAn"
        }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
          onClick: function onClick(e) {
            e.stopPropagation();
            onCreateSection(section.id.toString());
            setOpenPopoverSectionId('');
          },
          icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
          children: "Th\xEAm ph\u1EA7n b\xEAn d\u01B0\u1EDBi"
        })]
      })
    });
  };

  var renderSectionSummaries = function renderSectionSummaries() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: sections.map(function (section, sectionIndex) {
        var id = section.id;
        var sectionId = id.toString();
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(PanelSection, {
            className: generateSectionActiveClass(sectionIndex),
            onClick: function onClick() {
              return onUpdateSectionSelected(sectionIndex + 1);
            },
            children: [/*#__PURE__*/_jsxs(PanelTitleSection, {
              children: ["Ph\u1EA7n ", sectionIndex + 1, ". ", section.title]
            }), /*#__PURE__*/_jsxs(PanelScoreSection, {
              children: [section.totalScore === 0 ? '-' : section.totalScore, /*#__PURE__*/_jsx(Popover, {
                placement: "right",
                content: moreContent(section),
                open: sectionId === openPopoverSectionId,
                onOpenChange: function onOpenChange() {
                  var isPopOverVisible = sectionId === openPopoverSectionId;
                  setOpenPopoverSectionId(isPopOverVisible ? '' : sectionId);
                },
                trigger: 'click',
                children: /*#__PURE__*/_jsx(MoreButton, {
                  size: "large",
                  icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
                  type: "text",
                  shape: "circle",
                  onClick: function onClick(e) {
                    e.stopPropagation();
                  }
                })
              })]
            })]
          }), /*#__PURE__*/_jsx(PanelQuestion, {
            className: generateSectionExpandClass(sectionIndex)
          })]
        }, sectionId);
      })
    });
  };

  var renderLoadingEffect = function renderLoadingEffect() {
    return /*#__PURE__*/_jsx(LoadingArea, {
      children: /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 4
        }
      })
    });
  }; // const renderQuestionSummaries = useCallback(
  //   (section: SectionSummary, sectionIndex: number): ReactNode => {
  //     if (isLoadingGetQuestionSummaries) {
  //       return renderLoadingEffect();
  //     }
  //     const { questions } = section;
  //     return (
  //       <>
  //         {questions?.map((question, questionIndex) => {
  //           return (
  //             <PanelTitleQuestion
  //               key={question.id.toString()}
  //               onClick={() => onSelectQuestion(sectionIndex + 1, questionIndex)}
  //               className={selectedQuestionIndex === questionIndex ? activeClass : null}
  //             >
  //               <QuestionTitleWrapper>
  //                 <QuestionDescription dangerouslySetInnerHTML={{ __html: question.description }} />
  //               </QuestionTitleWrapper>
  //               <span>{question.score}</span>
  //             </PanelTitleQuestion>
  //           );
  //         })}
  //       </>
  //     );
  //   },
  //   [isLoadingGetQuestionSummaries, onSelectQuestion, selectedQuestionIndex],
  // );


  return /*#__PURE__*/_jsxs(CollapseContainer, {
    children: [/*#__PURE__*/_jsx(SectionSummaryListContainer, {}), /*#__PURE__*/_jsxs(PanelTitleTotalScore, {
      children: [/*#__PURE__*/_jsx(PanelTitleSection, {
        children: "T\u1ED5ng \u0111i\u1EC3m"
      }), /*#__PURE__*/_jsx(PanelTitleSection, {
        children: totalQuestionScore
      })]
    })]
  });
};